export default __webpack_public_path__ + "static/media/BB_24.8e7fc971.png";